// src/components/ScrollToTopButton.jsx
import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 200);
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
   <button
  onClick={scrollToTop}
  aria-label="Scroll to top"
  className={`fixed bottom-28 right-6 md:bottom-25 md:right-10 p-3 rounded-full bg-sky-500 text-white shadow-lg transition-all duration-300 hover:bg-sky-600 focus:outline-none ${
    isVisible
      ? "opacity-100 translate-y-0"
      : "opacity-0 translate-y-8 pointer-events-none"
  }`}
  style={{
    zIndex: 900,
  }}
>
  <FaArrowUp size={18} />
</button>

  );
};

export default ScrollToTopButton;
